// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingOverlay_wrapper_vAJ20","label":"LoadingOverlay_label_H5F5D"};